import { SelectorOption } from "../../../../components/Redux/BasicSelector";

export const HealthCheckOptions: SelectorOption[] = [
  {
    label: "Choose Health Check Type",
    id: "",
  },
  {
    label: "HTTP",
    id: "http",
  },
  {
    label: "TCP",
    id: "tcp",
  },
  {
    label: "GRPC",
    id: "grpc",
  },
];
